window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/*============================================================================
  Enavi Custom Reorder Collections
==============================================================================*/

theme.EnaviCollectionReorder = (function() {
  const selectors = {
    collectionGrid: '.enavi-custom-collection-grid',
    progressBar : '.progress-bar',
    loadMoreBtn : '.load-more-button',
    visibleProductsNumber: '.product-initial-count',
    totalProductsNumber: '.product-final-count'
  };

  function EnaviCollectionReorder(container) {
    if(container){
     this.container = container; 
     this.init();
     this.firstRun = true;
    }
  };

  EnaviCollectionReorder.prototype = Object.assign({}, EnaviCollectionReorder.prototype, {
    init: async function() {
      this.collectionGrid = this.select(selectors.collectionGrid);
      this.progressBar = this.select(selectors.progressBar);
      this.loadMoreBtn = this.select(selectors.loadMoreBtn);
      this.showingText = this.select(selectors.visibleProductsNumber);
      this.totalItemsText = this.select(selectors.totalProductsNumber);
      this.customSortEnabled = await this.isSortByManual();

      if(this.firstRun){
        this.addEventListeners();
      }
      
      if (this.customSortEnabled) {
        this.sortProducts();
        this.setInitialElements();
        this.loadMoreBtn.addEventListener('click', this.loadMoreProducts.bind(this));
      }
    },  

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    addEventListeners:  function(){
      // this.submitButton.addEventListener('click', this.validateEmail.bind(this));
      window.addEventListener('enaviCollectionRendered', () => {
        this.init();
      });

      this.firstRun = false;
    },

    sortProducts: function() {
      if (!window.enaviCustomSortOrder) {
        return;
      }
      let items = {};
      let productCounter = 0;
      let unsortedItems = [];

      // Store all items in an object with their IDs as keys
      this.collectionGrid.querySelectorAll('.unit-product-card').forEach(function(node) {
        let id = node.getAttribute('data-card-variant-id');
        items[id] = node;
        unsortedItems.push(id);
      });

      // Clear the container
      this.collectionGrid.innerHTML = '';

      // Append items in sorted order and apply hidden class as needed
      enaviCustomSortOrder.forEach(function(id) {
        if (items[id]) {
          productCounter++;
          if (productCounter > 21) {
            items[id].classList.add('hidden-product'); // Add hidden class after 21 products
          }
          this.collectionGrid.appendChild(items[id]);
          unsortedItems.splice(unsortedItems.indexOf(id), 1);
        } else {
          console.log('SORT ITEM NOT FOUND: ' + id);
        }
      }, this);

      // Append unsorted items at the end
      unsortedItems.forEach(function(id) {
        this.collectionGrid.appendChild(items[id]);
        items[id].classList.add('hidden-product');
      }, this);
    },

    loadMoreProducts: function() {
      var hiddenProducts = this.selectAll('.hidden-product');
      var count = 0;
      
      // Show the next set of products and update the totalShown
      hiddenProducts.forEach(function(product) {
        if (count < 39) {
          product.classList.remove('hidden-product');
          count++;
        }
      });
      this.setInitialElements();
    },
    setInitialElements: function(){
      var hiddenProducts = this.selectAll('.hidden-product');
      var totalShown = 0;
      var totalProducts = window.enaviCustomSortOrder.length; // Assuming sortOrder array has all product IDs
      // Count the total number of products already shown
      var allProducts = this.selectAll('.unit-product-card');
      allProducts.forEach(function(product) {
        if (!product.classList.contains('hidden-product')) {
          totalShown++;
        }
      });
      // Update the progress bar
      var progressPercentage = (totalShown / totalProducts) * 100;
      if (this.progressBar) {
        this.progressBar.style.width = progressPercentage + '%';
        this.progressBar.setAttribute('aria-valuenow', progressPercentage);
      }
      // Update the text showing the number of items displayed
      if (this.showingText && this.totalItemsText) {
        this.showingText.textContent = totalShown;
        // Check if this is the last set of products
        if (hiddenProducts.length == 0) {
          this.loadMoreBtn.style.display = 'none'; // Hide the Load More button if no more products are hidden
        }
      }
    },
    isSortByManual: async function() {
      var queryParams = new URLSearchParams(window.location.search);
      var sortBy = queryParams.get('sort_by');
      return sortBy === 'manual' || !sortBy;
    }
    
  });

  return EnaviCollectionReorder;
})();

new theme.EnaviCollectionReorder(document.querySelector('#CollectionProductGrid'));